import { urlDateToDateTime } from 'common/UrlDate';
import React, { useRef } from 'react';
import { RouteChildrenProps } from 'react-router';
import { useOutsideClick } from 'rooks';
import { useDishFistCartPositionContext } from 'src/pages/consumer/components/ConsumerHeaderWrapper';
import { cartDropShadow, ConsumerOrderCart } from 'src/pages/consumer/order/components/ConsumerOrderCart';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import { getLocalTimezone } from 'src/shared/utils/DateTimeUtilities';
import styled from 'styled-components';
import { ScreenWidth, ZIndex } from 'web-common/src/shared/styles';

const SLIDING_CART_COL_ID = 'sliding-cart-col';

export const CartCol = styled.div<{ open: boolean }>`
  flex-shrink: 0;
  position: fixed;
  top: 0;
  right: 0;
  height: 0;
  width: 400px;
  transition: width 0.2s ease, transform 0.2s ease;
  z-index: ${ZIndex.SlideOutCart};
  transform: ${ifProp('open', 'translateX(0%)', 'translateX(100%)')};

  @media (max-width: ${ScreenWidth.SMALL}) {
    display: none;
  }

  ${cartDropShadow}
`;

interface DishFirstExploreCartProps {
  routeChildrenProps: RouteChildrenProps;
}

export const DishFirstExploreCart: React.FC<DishFirstExploreCartProps> = ({ routeChildrenProps }) => {
  const cartPositionState = useDishFistCartPositionContext();
  const cartCallRef = useRef<HTMLDivElement>(null);
  useOutsideClick(cartCallRef as React.MutableRefObject<HTMLDivElement>, (e) => {
    const cartCol = document.getElementById(SLIDING_CART_COL_ID);
    // for some reason when nodes get removed (i.e. remove all of an item, adding a suggested side, etc.)
    // they get registed as an outside click. we do an extra check to make sure that we really aren't
    // inside the container before closing it when it's not desirable to...
    const isActuallyInside = !!e.composedPath().find((node) => node === cartCol);
    if (isActuallyInside) return;
    if (cartPositionState.isOpen) cartPositionState.close();
  });

  // TODO: hook up checkout, delivery date, and remove shef requirement in following task:
  // https://app.asana.com/0/1202647408224810/1202802276871912/f
  return (
    <CartCol id={SLIDING_CART_COL_ID} data-cy={SLIDING_CART_COL_ID} open={cartPositionState.isOpen} ref={cartCallRef}>
      {/* foodItems prop - used for free delivery upsell modal which is currently disabled currently for dish first */}
      <ConsumerOrderCart
        foodItems={[]}
        shef={{ shefProfile: { isTrialShef: false } } as any}
        checkout={() => console.log('TODO')}
        deliveryDate={urlDateToDateTime('2022-09-19', getLocalTimezone())}
        setDeliveryDate={() => console.log('TODO')}
        match={routeChildrenProps.match}
        location={routeChildrenProps.location}
        isEditingOrder={false}
      />
    </CartCol>
  );
};
